import { useState, useCallback } from "react";
export const useForceUpdate = () => {
  const [tick, setTick] = useState(1);
  const update = useCallback(() => {
    if (tick) setTick((tick) => tick + 1);
  }, []);
  return update;
};
